import { POST_ORDER_ACCEPTED, RESET_POST_ORDER, CANCEL_POST_ORDER, CHECK_IN_REQUEST, FETCH_CASH_TRANSCATION_ID, ADD_HOPE_PAY_ACCEPTED, GIFT_CARD_PURCHASE } from '../../constants';
export function getPostOrderAccepted(payload, successCallback = null, errorCallback = null) {
    return {
        type: POST_ORDER_ACCEPTED,
        payload,
        successCallback,
        errorCallback,
    };
}
export function resetPostOrder() {
    return {
        type: RESET_POST_ORDER,
    };
}
export function fetchCashTransactionIdAction(payload) {
    return {
        type: FETCH_CASH_TRANSCATION_ID,
        payload,
    };
}
export function cancelPostOrder(payload, successCallback = null, errorCallback = null) {
    return {
        type: CANCEL_POST_ORDER,
        payload,
        successCallback,
        errorCallback,
    };
}
export function checkInRequest(payload, successCallback = null, errorCallback = null) {
    return {
        type: CHECK_IN_REQUEST,
        payload,
        successCallback,
        errorCallback,
    };
}
export function getAddHopeOrderAccepted(payload, successCallback = null, errorCallback = null) {
    return {
        type: ADD_HOPE_PAY_ACCEPTED,
        payload,
        successCallback,
        errorCallback,
    };
}
export function getGiftCardPurchaseAccepted(payload, successCallback = null, errorCallback = null) {
    return {
        type: GIFT_CARD_PURCHASE,
        payload,
        successCallback,
        errorCallback,
    };
}
